<template>
  <div class="ShowMore" @click="showMore">
    {{str}}
  </div>
</template>

<script>
  export default {
    name: 'ShowMore',
    data () {
      return {
        str: '点击显示更多'
      }
    },
    props: {
      listall: {
        type: Number
      },
      listshow: {
        type: Number
      },
      count: {
        type: Number,
        default: 10
      }
    },
    methods: {
      showMore () {
        if (this.listshow === this.listall) {
          this.$emit('update:listshow', this.count)
        } else if (this.listshow + this.count > this.listall) {
          this.$emit('update:listshow', this.listall)
        } else {
          this.$emit('update:listshow', this.listshow + this.count)
        }
      },
      changStr () {
        if (this.listshow < this.listall) {
          this.str = '点击显示更多'
        } else if (this.listshow === this.listall) {
          this.str = '收起列表'
        } else {
          this.str = ''
        }
      }
    },
    watch: {
      listall: function () {
        this.changStr()
      },
      listshow: function () {
        this.changStr()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/common.styl"
  .ShowMore
    padding 20px 0 20px 0
    font-size 12px
    color $font_color5
    line-height 12px
    text-align center
</style>



// WEBPACK FOOTER //
// ShowMore.vue?f7e6b512